import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CardV2, Pill, Text } from '@feathr/components';

interface IGoalDetailSegmentationProps {
  convertersUrl: string;
  uniqueConverters: number;
}

function GoalDetailSegmentation({
  convertersUrl,
  uniqueConverters,
}: Readonly<IGoalDetailSegmentationProps>): JSX.Element {
  const { t } = useTranslation();
  const hasConverters = uniqueConverters > 0;

  return (
    <CardV2 name={'goal-segmentation'} width={'full'}>
      <CardV2.Header title={t('Segmentation')}>
        <Pill theme={'violet'} variant={'secondary'}>
          {t('Auto-generated')}
        </Pill>
      </CardV2.Header>
      <CardV2.Content addVerticalGap={true}>
        <Text.DefaultRegular truncate={false}>
          {t(
            "Save everyone who's converted on this goal as an auto-updating segment to retarget, steward, or export.",
          )}
        </Text.DefaultRegular>
        <Button
          disabled={!hasConverters}
          link={hasConverters ? convertersUrl : undefined}
          tooltip={hasConverters ? undefined : t('No converters yet')}
          type={'secondary'}
        >
          {t('View converters ({{count}})', { count: uniqueConverters })}
        </Button>
      </CardV2.Content>
    </CardV2>
  );
}

export default observer(GoalDetailSegmentation);
